import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `Language`
};

export function useLanguageStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [classNames.root, {}]
    }),
    []
  );
}
